import type { InviteUserFormValues, UpdateUserProfileFormValues } from '@/schemas/user.schema';

import type { CurrentUser, User, UserInvitation } from '@/types/user.type';

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapUserResponse = (data: Record<string, any>): User => {
  return {
    id: data.id,
    email: data.email,
    first_name: data.first_name,
    last_name: data.last_name,
    role: {
      id: data.role.id,
      name: data.role.name,
    },
    status: data.status,
  };
};

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapCurrentUserResponse = (payload: Record<string, any>): CurrentUser => {
  const data = payload.data;

  return {
    id: data.id,
    email: data.email,
    first_name: data.first_name,
    last_name: data.last_name,
    full_name: data.first_name + ' ' + data.last_name,
    phone_number: data.phone_number,
    last_logged_in_at: data.last_logged_in_at,
    cognito_id: data.cognito_id,
    created_at: data.created_at,
    permissions: data.permissions || [],
    last_password_change_at: data.last_password_changed_at,
    role: {
      id: data.role.id,
      name: data.role.name,
    },
  };
};

export const mapUpdateProfileRequest = (
  data: UpdateUserProfileFormValues
): Record<string, string> => {
  return {
    first_name: data.first_name,
    last_name: data.last_name,
    phone_number: data.phone_number,
  };
};

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapUserInvitationResponse = (data: Record<string, any>): UserInvitation => {
  return {
    id: data.id,
    email: data.email,
    role_id: data.role_id,
    role: data.role ? { id: data.role.id, name: data.role.name } : undefined,
    status: data.status,
    invited_by: data.invited_by,
    invited_by_name: data.invited_by_name,
    created_at: data.created_at,
    expires_at: data.expires_at,
  };
};

export const mapInviteUserRequest = (data: InviteUserFormValues): Record<string, unknown>[] => {
  const users = data.users.map(user => ({
    email: user.email,
    role: Number(user.role),
  }));

  return users;
};
